<div class="app-modal-spinner">
  <div class="container">
      <h2 *ngIf="user">{{userName}}</h2>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <app-record-field
        [record]="record"
        [staffList]="scheduleService.setDefaultStaff(record, staffList)"
        [form]="form"
        [disabled]="disabled"
        [duplicate]="duplicate"
      ></app-record-field>
      <app-edit-footer
        [navigationFinally]="historyBackWard"
        excuteText="保存"
        [disabled]="form.invalid || disabled || isSubmit"
      ></app-edit-footer>
    </form>
  </div>
</div>
